import { createAction } from '@reduxjs/toolkit';
export const setIsInitializing = createAction('authentication/setIsInitializing');
export const setIsAuthenticated = createAction('authentication/setIsAuthenticated');
export const setUser = createAction('setUser');
export const setToken = createAction('setToken');
export const removeToken = createAction('removeToken');
export const setDefaultSite = createAction('setDefaultSite');
export const setDefaultSiteName = createAction('setDefaultSiteName');
export const setClient = createAction('setClient');
export const setTeams = createAction('setTeams');
export const setLogoutFunction = createAction('setLogoutFunction');
